import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { useStyle } from '@composables/use-style';
import { CONTACTS } from '@constants';
import { ENTRY_POINTS } from '@constants/entry-points';
import { IMAGE_FILES } from '@constants/ui-constants';
import HeaderPrimary from '@v1/components/header/HeaderPrimary.vue';
import ImagePrimary from '@v1/components/image/ImagePrimary.vue';
import LinkPrimary from '@v1/components/link/LinkPrimary.vue';
import TextPrimary from '@v1/components/text/TextPrimary.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Error404View',
  setup(__props) {

const { t } = useI18n();

const { spacing } = useStyle();

const style = ref({
  container: {
    footer: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: spacing.MD,
      justifyContent: 'space-between',
      width: '100%',
    },
    header: {
      image: {
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-start',
      },
      outer: {
        display: 'flex',
        gap: spacing.MD,
        width: '100%',
      },
      text: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        gap: spacing.SM,
        justifyContent: 'center',
        width: 'clamp(fit-content, 100%, 100%)',
      },
    },
  },
  header: {
    fontSize: spacing.XXXL,
  },
  image: {
    maxWidth: '240px',
    minWidth: '240px',
    width: '100%',
  },
  inner: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.XL,
    height: '100%',
    justifyContent: 'center',
    maxWidth: '480px',
    width: '100%',
  },
  link: {
    width: 'fit-content',
  },
  outer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.MD,
    height: '100%',
    justifyContent: 'center',
    minHeight: '100vh',
    minWidth: '272px',
    padding: spacing.LG,
    width: '100%',
  },
});

const asset = ref(IMAGE_FILES.PLACEHOLDER.GENERAL);

const toDashboard = ref(ENTRY_POINTS.PATH.TENANT_HOME());
const hrefContact = ref(`mailto: ${CONTACTS.SUPPORT}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(style.value.outer)
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle(style.value.inner)
    }, [
      _createElementVNode("div", {
        style: _normalizeStyle(style.value.container.header.outer)
      }, [
        _createElementVNode("div", {
          style: _normalizeStyle(style.value.container.header.image)
        }, [
          _createVNode(ImagePrimary, {
            asset: asset.value,
            style: _normalizeStyle(style.value.image)
          }, null, 8, ["asset", "style"])
        ], 4),
        _createElementVNode("div", {
          style: _normalizeStyle(style.value.container.header.text)
        }, [
          _createVNode(HeaderPrimary, {
            size: "XL",
            style: _normalizeStyle(style.value.header)
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode(" 404 ", -1)
            ])),
            _: 1,
            __: [0]
          }, 8, ["style"]),
          _createVNode(HeaderPrimary, { size: "LG" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('errors.notFound.header')), 1)
            ]),
            _: 1
          })
        ], 4)
      ], 4),
      _createVNode(TextPrimary, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('errors.notFound.body')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        style: _normalizeStyle(style.value.container.footer)
      }, [
        _createVNode(LinkPrimary, { to: toDashboard.value }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('errors.notFound.backToDashboard')), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(LinkPrimary, { href: hrefContact.value }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('errors.notFound.contactSupport')), 1)
          ]),
          _: 1
        }, 8, ["href"])
      ], 4)
    ], 4)
  ], 4))
}
}

})